import { Franchise } from '@/types';
import { Modal, Typography } from 'antd';
import { FC } from 'react';
import './index.scss';

interface Props {
  open: boolean;
  onClose: () => void;
  onDelete: (franchiseId: string, franchableName: string) => void;
  franchise: Franchise | null;
  deleting?: boolean;
}

const DeleteBrandMappingModal: FC<Props> = ({
  open,
  onClose,
  onDelete,
  franchise,
  deleting = false,
}) => {
  const handleDelete = () => {
    if (franchise) {
      onDelete(franchise._id, franchise.franchableName || '');
      onClose();
    }
    };
    

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable
      centered
      className="brand-mapping-modal"
      width={380}
    >
      <div>
        <Typography.Title level={4} style={{ margin: 0 }}>
          Delete Franchable Name
        </Typography.Title>
        <Typography.Text type="secondary" style={{ marginTop: 8, display: 'block' }}>
          Are you sure you want to delete &quot;{franchise?.franchableName}&quot;?
        </Typography.Text>
        <Typography.Text type="secondary" style={{ marginTop: 8, display: 'block' }}>
          This action cannot be undone.
        </Typography.Text>
        
              

        <div className="brand-mapping-modal__footer">
          <button
            className="brand-mapping-modal__btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="brand-mapping-modal__btn-save"
            onClick={handleDelete}
            disabled={deleting}
          >
            {deleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteBrandMappingModal;
